import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const FormEntrySingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    const rows: any[] = []
    const formData = {};
    let n = 0;

    data.data.map((data, key) => {

        n++;

        if (!data.key) data.key = n.toString();

        formData[data.key] = data.value;

        rows.push({
            label: data.label,
            key: 'entryData.'+data.key
        });

        return rows

    });

    data.entryData = formData

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Form Entry Details"}
                >
                    <MetaTable
                        data={data}
                        columnA={rows}
                        columnB={[
                            {
                                label: "User Full Name",
                                key: "owner",
                                format: 'ModelLink'
                            },
                            {
                                label: "User Email",
                                key: "owner.email",
                            },
                            {
                                label: "Order ID",
                                key: "order",
                                format: 'ModelLink'
                            },
                            {
                                label: "Form",
                                key: "form",
                                format: 'ModelLink'
                            },
                            {
                                label: "Date Submitted",
                                key: "createdAt",
                                format: "dateTime",
                            },
                            {
                                label: "Payment Gateway",
                                key: "order.paymentGateway",
                            },
                            {
                                label: "Payment Status",
                                key: "order.status",
                            },
                            {
                                label: "Product Name",
                                key: "order.item.title",
                            },
                            {
                                label: "Date Paid",
                                key: "date",
                                format: "dateTime"
                            }
                        ]}
                        columnC={[
                            {
                                label: "Created On",
                                key: "created",
                                format: "onAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default FormEntrySingleView;
